import React, { useState, Fragment } from 'react';
import { Card, Col, Container, Form, Row, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaSearch, FaEdit } from "react-icons/fa";
import { serviceGetDocumento } from '../../../api/api-aprobacion-objecion';
import { formatoMonto, resetFormatoMonto, resetFormatoMontoSinPunto} from '../../../common/Formatos';
import EditCartaCobro from './edit-carta-cobro'
import { useFormik } from 'formik'
import { validationSchemasRecuperacionCobro } from '../../../common/validation-Schemas-recuperacion-cobro';
import { serviceRecepcionar } from '../../../api/api-recuperacion-cobro';
import { Auth, LoadingComponent } from 'recupero-comunes'
import Mensajes from '../../mensajes'

const HeaderInfo = ({ cfg_form, implicado, idCaso, idOrgCaso, codClasCaso, getDatosImplicado }) => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [responseData, setResponseData] = useState(null);
    const { rutUsuario } = Auth.currentUser();
    const [ciaImplicado, setCiaImplicado] = useState("");

    const handleInforme = async () => {
        if (implicado?.idfolioCargaDocto) {
            setLoading(true); 
            let query = Buffer.from(JSON.stringify({
                idCaso: idCaso,
                idImplicadoCaso: implicado?.IdImplicado,
                idCompania: idOrgCaso,
                idfolioCarga: implicado?.idfolioCargaDocto
            })).toString('base64')

            const response = await serviceGetDocumento(query);
            setLoading(false);

            var link = document.createElement("a");
            link.download = response.filename;
            link.href = "data:" + response.mimetype + ";base64," + response.file;
            link.click();
        }
    }

    const verEdicionDatosCarta = async () => {
        setShowModal(true);
    }
    const validateMontoMoneda = (value, action) => {
        let monto = 0;
        
        if (action === 'format') monto = formatoMonto(value);
        else {
            if (Number(formik.values.moneda) === 30001) monto = resetFormatoMontoSinPunto(value);
            else monto = resetFormatoMonto(value);
        }

        return monto;
    }
    const postActualizarDatosCarta = async (data) => {
        setLoading(true)
        const response = await serviceRecepcionar(data);

        setResponseData(response);
        setLoading(false);
        setShowToast(true);
    }
    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) { 
            formik.resetForm();
            setShowModal(false);
            getDatosImplicado();
        }
    }
    const formik = useFormik({
        initialValues: {
            idCompaniaIM: "",
            idSiniestroIM: "",
            fechaSiniestroIM: "",
            fechaCarta: "",
            moneda: "",
            montoCosto: "",
            porcConvenio: "",
            montoRecobro: "",
            companiaIM: "",
            accion:99
        },
        validationSchema: validationSchemasRecuperacionCobro(1500),
        onSubmit: async (data) => {
            let dataResult = { ...data };
            dataResult.idCaso = idCaso;
            dataResult.idOrganizacion = idOrgCaso;
            dataResult.idImplicadoCaso = implicado?.IdImplicado;
            dataResult.idUsuario = rutUsuario;
            
            dataResult.montoCosto = Number(validateMontoMoneda(data.montoCosto, 'reset_format', data.moneda));
            dataResult.montoRecobro = Number(validateMontoMoneda(data.montoRecobro, 'reset_format', data.moneda));

            dataResult.fechaCarta = data.fechaCarta.split('-').join('');
            dataResult.fechaSiniestroIM = data.fechaSiniestroIM.split('-').join('');
            dataResult.companiaIM = ciaImplicado;
            dataResult.idCiaImplicadoOld = implicado?.IdCiaImplicado;
            
            //console.log("dataResult antes de post: ", dataResult)
            postActualizarDatosCarta(dataResult)
        }
    })
    return (
        <Fragment>
            <LoadingComponent show={loading} />
                <Card>
                    <Card.Header as='h6' style={{ backgroundColor: "rgb(209, 242, 235)", color: 'color: rgb(255, 255, 255)' }}>
                        {cfg_form && cfg_form["aprobobjcartacobrotercero-subtitle1"]}
                        <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Editar datos Carta</Tooltip>}>
                            <Button style={{ backgroundColor: "rgb(209, 242, 235)", float: 'right'}} size="sm">
                                <FaEdit
                                    size={20}
                                    color='gray'
                                    onClick={verEdicionDatosCarta}
                                />
                            </Button>
                        </OverlayTrigger>
                    </Card.Header>
                    <Card.Body>
                        <Container>
                            <Row>
                                <Col md='3' className='mb-2'>
                                    <Form.Label className='label'>
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-compania"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {implicado && implicado.CiaImplicado}
                                    </Form.Text>
                                </Col>
                                <Col md='2' className='mb-2'>
                                    <Form.Label className='label'>
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-sinitercero"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {implicado && implicado.SiniestroIM}
                                    </Form.Text>
                                </Col>
                                <Col md='2' className='mb-2'>
                                    <Form.Label className='label'>
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-fechasinitro"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {implicado && implicado.FechaSiniestroIMFormat}
                                    </Form.Text>
                                </Col>
                                <Col md='3' className='mb-2'>
                                    <Form.Label className='label'>
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-fecharecepcarta"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {implicado && implicado.FechaEnvioCartaCobroFormat}
                                    </Form.Text>
                                </Col>
                                <Col md='2' className='mb-2'>
                                    <Form.Label className='label'>
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-estado"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {implicado && implicado.EstadoImplicado}
                                    </Form.Text>
                                </Col>

                                <Col md='3' className='mb-2'>
                                    <Form.Label className='label'>
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-moneda"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {implicado && implicado?.GlosaMonedaRecobro}
                                    </Form.Text>
                                </Col>
                                <Col md='2' className='mb-2'>
                                    <Form.Label className='label'>
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-montoneto"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {implicado && formatoMonto(implicado.MontoCosto)}
                                    </Form.Text>
                                </Col>
                                <Col md='2' className='mb-2'>
                                    <Form.Label className='label'>
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-porcconvenio"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {implicado && implicado.PorConvenido}
                                    </Form.Text>
                                </Col>
                                <Col md='3' className='mb-2'>
                                    <Form.Label className='label'>
                                        {cfg_form && cfg_form["aprobobjcartacobrotercero-lbl-montorecobro"]}
                                    </Form.Label>
                                    <br />
                                    <Form.Text>
                                        {implicado && formatoMonto(implicado.MontoRecobro)}
                                    </Form.Text>
                                </Col>
                                <Col md='2' className='mb-2'>
                                    <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>{implicado?.idfolioCargaDocto ? "Ver Carta" : "No existe Carta"}</Tooltip>}>
                                        <Button variant='light'>
                                            <FaSearch
                                                size={20}
                                                color='gray'
                                                onClick={handleInforme}
                                            />
                                        </Button>
                                    </OverlayTrigger>
                                </Col>
                            </Row>
                        </Container>
                    </Card.Body>
                </Card>                
            <Form onSubmit={formik.handleSubmit} style={{ marginBottom: '-5px' }}>
                <EditCartaCobro
                    cfg_form={cfg_form}
                    formik={formik}
                    idCaso={idCaso}
                    idImplicado = {implicado?.IdImplicado}
                    codClasCaso={codClasCaso}
                    showModal={showModal}
                    setShowModal={setShowModal}     
                    setCiaImplicado={setCiaImplicado}
                    showToast={showToast}
                    responseData={responseData}
                    handleCloseToast={handleCloseToast}
                />
            </Form>
        </Fragment>
    )
}

export default HeaderInfo;